import React from 'react';
import { Header } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import DictionaryChanger from '../../dictionaries/containers/DictionaryChanger';
import DictionaryFieldChanger from '../containers/DictionaryFieldChanger';

const FieldInformationHeader = ({ category, code, errors }) => (
  <Header as="h4" className="aridhia-lookup-information-header font-weight-dark relative">
    <FormattedMessage id="dataset.dictionary.showing.header" />
    <DictionaryFieldChanger category={category} code={code} />
    <FormattedMessage id="dataset.dictionary.showing.in.header" />
    <DictionaryChanger category={category} code={code} saveErrors={errors} />
  </Header>
);

export default FieldInformationHeader;
